import gql from 'graphql-tag';

export const GET_ORDER_BY_ID = gql`
    query Order($_id: ID!) {
        orderById(_id: $_id) {
            _id
            code
            quantities {
                article {
                    _id
                    name
                }
                quantity
                price
            }
            paymentStatus
            sellerGroup {
                _id
                code
            }
        }
    }
`;
